export default __webpack_public_path__ + "static/metamask-052e8e0f610895ca24b2f339114a7884.svg";